import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import authService from './authService';
const initialState = {
    user: null,
    error: false,
    message: ""
}
// Login User
export const login = createAsyncThunk(process.env.REACT_APP_FIND_API_URL + '/auth/login-seller-user', async (user, thunkApi) => {
    try {
        const res = await authService.login(user);
      return res
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.error.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
});
export const currentUser = createAsyncThunk(process.env.REACT_APP_FIND_API_URL + '/auth/get-user-by-accesstoken', async(refreshToken,thunkApi)=> {
    try {
        const res = await authService.getUser(refreshToken)
        console.log(res);
        return res;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.error.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue(message);
    }
})
export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state,action)=>{
            state.user = action.payload.user.user
        },
        logout:(state,action)=>{
            state.user = null
        },
        addUser:(state, action)=> {
            state.user = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.fulfilled, (state, action) => {
                state.user = action.payload.user
            })
            .addCase(login.rejected, (state, action) => {
                state.user = null
                state.error = true
                state.message = action.payload
            })
            .addCase(currentUser.fulfilled, (state, action)=> {
                state.user = action.payload
            })
    }
});
export const authActions = authSlice.actions;
export default authSlice.reducer;